import * as React from 'react';
import Top from "../Top";

import { useLocation, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import Private from '../Policy/Private';
import Terms from '../Policy/Terms';
import JoinAgreePop from "./JoinAgreePop";
import tabbg from "../../assets/images/tab_05.png"

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const JoinAgree = () => {
  const navigate = useNavigate();

  const [state, setState] = React.useState({

    bottom: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };


  const [checked, setChecked] = React.useState([true, false, false, false, false]);

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, event.target.checked, event.target.checked, event.target.checked, event.target.checked]);
  };

  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, checked[1], checked[2], checked[3], checked[4]]);
  };

  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], event.target.checked, false, false, false]);
  };

  const handleChange4 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], event.target.checked, checked[3], checked[4]]);
  };

  const handleChange5 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], checked[2], event.target.checked, checked[4]]);
  };

  const handleChange6 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], checked[2], checked[3], event.target.checked]);
  };

  const children = (
    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
      <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1 }}>
        <FormControlLabel
          label="서비스 이용약관(필수)"
          control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[0]} onChange={handleChange2} />}
          sx={checkBtn}
        />
        {(['bottom'] as const).map((anchor) => (
          <React.Fragment key={anchor}>
            <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999' }} onClick={toggleDrawer(anchor, true)} />
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              <Stack sx={{
                '& header': { display: 'none' },
                '& .contentStart': { mt: 0 },
                '& .MuiBottomNavigation-root': { display: 'none' }
              }}>
                <HighlightOffIcon sx={{ ml: 'auto', color: '#c10b0b', p: 2, fontSize: 30 }} onClick={toggleDrawer(anchor, false)} />
                {/* <Divider /> */}
                <Terms />
              </Stack>

            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Stack>
      <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5 }}>
        <FormControlLabel
          label="개인정보 처리방침(필수)"
          control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[1]} onChange={handleChange3} />}
          sx={checkBtn}
        />

        {(['bottom'] as const).map((anchor) => (
          <React.Fragment key={anchor}>
            <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999' }} onClick={toggleDrawer(anchor, true)} />
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              <Stack sx={{
                '& header': { display: 'none' },
                '& .contentStart': { mt: 0 },
                '& .MuiBottomNavigation-root': { display: 'none' }
              }}>
                <HighlightOffIcon sx={{ ml: 'auto', color: '#c10b0b', p: 2, fontSize: 30 }} onClick={toggleDrawer(anchor, false)} />
                {/* <Divider /> */}

                <Private />
              </Stack>

            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Stack>
    </Box>
  );
  const img = {
    backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2, width: '100%', height: 200, mt: 1
  }
  return (
    <Box sx={{ width: '60%', ml: 'auto', mr: 'auto' }}>
      <Box sx={img}><Typography sx={{ color: '#fff', textAlign: 'center', fontSize: 25, lineHeight: '200px' }}>이용 약관 동의</Typography></Box>
      <Container sx={Logbg}>
        <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
          <Box sx={{ ml: 'auto', mr: 'auto', textAlign: 'center' }}>
            <Box sx={{ pt: 4, pb: 2, width: '50%', ml: 'auto', mr: 'auto', textAlign: "center" }}>
              <Img alt="DualLogo" src="/dual_d.png" />
            </Box>

            <Typography sx={{ fontSize: 24, fontWeight: 700, ml: 2, color: '#555' }}>고객님 환영합니다!</Typography>
          </Box>

          <Stack direction={'row'} alignItems={'center'} sx={{ mt: 7, ml: 2, mr: 1 }}>
            <FormControlLabel
              label="전체 약관 동의"
              control={
                <Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />}
                  checked={checked[0] && checked[1] && checked[2] && checked[3] && checked[4]}
                  onChange={handleChange1}
                />}
              sx={checkBtn}

            />

          </Stack>
          <Divider sx={{ mt: 1, mb: 1 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1 }}>
              <FormControlLabel
                label="서비스 이용약관 (필수)"
                control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[0]} onChange={handleChange2} />}
                sx={checkBtn}
              />

              <JoinAgreePop type="terms" />
            </Stack>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1 }}>
              <FormControlLabel
                label="개인정보 처리방침 (필수)"
                control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[1]} onChange={handleChange3} />}
                sx={checkBtn}
              />

              <JoinAgreePop type="private" />
            </Stack>
            {
              checked[1] == true
                ? <>
                  <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                    <FormControlLabel
                      label="개인(민감)정보 수집 및 이용 동의 (필수)"
                      control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[2]} onChange={handleChange4} />}
                      sx={checkBtn}
                    />

                    <JoinAgreePop type="collect" />
                  </Stack>
                  <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                    <FormControlLabel
                      label="제3자 개인정보 제공 동의(건강검진 및 심리상담) (필수)"
                      control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[3]} onChange={handleChange5} />}
                      sx={checkBtn}
                    />

                    <JoinAgreePop type="third" />
                  </Stack>
                  <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                    <FormControlLabel
                      label="홍보 및 마케팅 수집·이용 동의서 (선택)"
                      control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[4]} onChange={handleChange6} />}
                      sx={checkBtn}
                    />

                    <JoinAgreePop type="ads" />
                  </Stack>
                </>
                : null
            }
          </Box>

        </Stack>

        <Box sx={{ bgcolor: '#f5f5f5', fontSize: 12, p: 1, mt: 4, color: '#555', textAlign: 'center', borderRadius: 20 }}>14세 미만은 가입할 수 없습니다.</Box>

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle} disabled={!(checked[0] && checked[1] && checked[2] && checked[3])}
            onClick={() => navigate('/Join/Join')}
          >
            다음
          </Button>
        </Box>

      </Container>
    </Box>
  );
}



const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const checkBtn = {
  '& .MuiCheckbox-root': { color: '#999' },
  '& .MuiCheckbox-root.Mui-checked': { color: '#0d6703' },
  '& .MuiFormControlLabel-label': { fontSize: 14 }
}

const loginField = {
  '& input': {
    fontSize: 14
  },

  '& label': {
    color: '#888',
    fontSize: 14
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#fff',
  pb: 4,
  minWidth: '320px',
  width: '80%',
  borderRadius: '15px',
  maxWidth: '80% !important',
  
}


const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 7,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  p: .5,
  boxSizing: 'border-box',
  color: '#fff',
  border: '0px solid #ef8322',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#0d6703',
    borderColor: '#0d6703',
  },
  ':focus': {
    boxShadow: 'none',
  },
};



export default JoinAgree;